import { axiosDelete, axiosGet, axiosPost } from "./HttpBaseService";


export const AuthService = {
    userLoggerIn: false,
    Login: (body: any) => {
        return axiosPost(`${process.env.REACT_APP_API}/auth/userLogin`, body)
    },
    AutoLogin: () => {
        return axiosGet(`${process.env.REACT_APP_API}/auth/autoLogin`)
    },
    getUser: () => {
        return axiosGet(`${process.env.REACT_APP_API}/admin/getUser`)
    },
    getUserById: (userId:any) => {
        return axiosGet(`${process.env.REACT_APP_API}/admin/getUserById/${userId}`)
    },
    logOut: () => {
        return axiosGet(`${process.env.REACT_APP_API}/auth/logout`)
    },
    deleteUserChatSession: (session:any,userId:string) => {
        return axiosPost(`${process.env.REACT_APP_API}/admin/deleteUserChatSession`,{...session,userId})
    }


} 